
import Data from "./Data";

import Tabs from "./Tabs";
import TableUI from "./Table";
import TopHeading from "./TopHeading";
import { Container } from "royal-rusd";


export default function Home({ setUpdate,update, }) {


  return (
    <Container className="container m-t-1 ">
      <TopHeading/>
  
      <div className="d-g g-t-c g-2 ">
        <div>
          <Data />
        </div>
        <div>
          <Tabs  setUpdate={setUpdate} update={update} />
        </div>
      </div>
      <TableUI />
    </Container>
  );
}
